import React from 'react';
import { LessonPlannerGridLayout } from './LessonPlannerGridLayout';
import { CardSwitch, LessonPlannerNavbar, LessonPlanAppHeader } from '.';
import { makeStyles } from '@mui/styles';
import LessonPlannerHeader from './LessonPlannerHeader';
import { useTheme } from '@mui/material';

export const LessonPlannerMain = ({
  lessons,
  selectedView,
  gridProps,
  onMoveCard,
  handleGoToTodayClick,
  handlePreviousClick,
  handleNextClick,
  lessonWeek,
  title,
  tourData = {} as any
}) => {
  const theme = useTheme();
  const classes = useStyles(theme)();

  return (
    <LessonPlanAppHeader>
      <LessonPlannerHeader highlight={tourData.highlightHeader} />
      <LessonPlannerNavbar
        title={title}
        lessonWeek={lessonWeek}
        handleNextClick={handleNextClick}
        handlePreviousClick={handlePreviousClick}
        handleGoToTodayClick={handleGoToTodayClick}
      />

      <LessonPlannerGridLayout className={classes.calendarGrid} {...gridProps}>
        <CardSwitch
          lessons={lessons}
          variant={selectedView}
          handleMoveCard={onMoveCard}
          tourData={tourData}
        />
      </LessonPlannerGridLayout>
    </LessonPlanAppHeader>
  );
};
const footerAndHeaderHeight = 150;
const filtersHeight = 173;
const useStyles = theme =>
  makeStyles(() => ({
    calendarGrid: () => ({
      backgroundColor: theme.palette.primary.light,
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      paddingBottom: '50px',
      paddingLeft: 0,
      paddingRight: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      minHeight: `calc(100vh - ${footerAndHeaderHeight + filtersHeight}px)`
    })
  }));
